import styled, { css, keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -60rem 0; }
  100% { background-position: 60rem 0; }
`;

/** The grey gradient of every skeleton, without the animation. */
const shimmerFill = css`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 120rem 100%;
`;

/** The animated grey fill shared by every skeleton loader, so they all look the same. */
const shimmerMixin = css`
  ${shimmerFill}
  animation: ${shimmer} 1.6s infinite linear;
`;

/**
 * A plain shimmering block of the given size. `$animated={false}` keeps the
 * fill but drops the animation: an infinite animation keeps costing CPU even
 * off screen, so skeletons that may sit there in large numbers stay static.
 */
const SkeletonBlock = styled.div<{
  width?: string;
  height?: string;
  margin?: string;
  $animated?: boolean;
}>`
  width: ${({ width }) => width ?? '100%'};
  height: ${({ height }) => height ?? '1.6rem'};
  margin: ${({ margin }) => margin ?? '0'};
  border-radius: 0.2rem;
  ${({ $animated = true }) => ($animated ? shimmerMixin : shimmerFill)}
`;

export { shimmerMixin, SkeletonBlock };
